import React from 'react'
import Text from '../text/Text'
import {TextInput} from '../../input/index'
import {PrimaryButton, SecondaryButton, TertiaryButtonDark} from '../../unilink/index'
//import reduce from 'lodash/reduce'
import './ask.css'

const AnswerTypes = {
  MULTIPLE_CHOICE: 'multiple_choice',
  TEXT_ENTRY: 'text_entry',
  CHECKBOX: 'checkbox',
}

const inputTypes = {
  [AnswerTypes.MULTIPLE_CHOICE]: 'radio',
  [AnswerTypes.CHECKBOX]: 'checkbox',
}

const ChoiceInput = ({className, type, value, id, onChange, checked, image}) => {
  if (image && image.isImageAdded) {
    return (
      <label htmlFor={id} className={className}>
        <input checked={checked} type={type} id={id} onChange={(e)=>onChange(id)} />
        <div className={`ask-content__answer-fakeinput-${type}`}><div /></div>
        <div className='ask-content__answer-image-container'>
          <img alt={image.displayName} src={`${window.CDN_URL}/${image.filename}`} />
          <span className={`ask-content__answer-value`} dangerouslySetInnerHTML={{__html:value[0].text}} />
        </div>
      </label>
    )
  } else {
    return (
      <label htmlFor={id} className={className}>
        <input checked={checked} type={type} id={id} onChange={(e)=>onChange(id)} />
        <div className={`ask-content__answer-fakeinput-${type}`}><div /></div>
        <span className={`ask-content__answer-value`} dangerouslySetInnerHTML={{__html:value[0].text}} />
      </label>
    )
  }
}

const Answer = ({answerType, answer, onChange, checked, isCorrect, hasSubmitted}) => {
  const classNames=['ask-content__answer', 'ask-content__answer--mc']
  if (hasSubmitted) {
    if (isCorrect && checked) {
      classNames.push('ask-content__answer--correct')
    } else if (checked) {
      classNames.push('ask-content__answer--incorrect')
    }
  }
  return (
    <div>
      <ChoiceInput
        className={classNames.join(' ')}
        onChange={onChange}
        type={inputTypes[answerType]}
        value={answer.value}
        image={answer.image}
        id={answer._id}
        checked={checked}
      />
      <div className='ask-content__answer-feedback'>
        {
          hasSubmitted && checked?
            <span dangerouslySetInnerHTML={{__html:answer.feedback[0].text}} />
            : null
        }
      </div>
    </div>
  )
}

const TextInputAnswer = ({onChange, isCorrect, hasSubmitted, givenAnswer, submitAnswer}) => {
  const classNames=['ask-content__answer']
  if (hasSubmitted) {
    if (isCorrect) {
      classNames.push('ask-content__answer--correct')
    } else {
      classNames.push('ask-content__answer--incorrect')
    }
  }
  return (
    <TextInput
      className={classNames.join(' ')}
      value={givenAnswer}
      onKeyPress={e=>{
        if (e.key === 'Enter') {
          e.preventDefault()
          e.stopPropagation()
          submitAnswer()
        }
      }}
      onChange={(e)=>onChange(e.target.value)} />
  )
}

const Ask = ({content, className, type, inputAnswer, submitAnswer, revealAnswer, disabled, as}) => {
  const {answerType, answers, question, hasSubmitted, isCorrect, givenAnswer} = content
  const classNames = ['ask-content']
  if (className) {
    classNames.push(className)
  }
  return (
    <form
      className={classNames.join(' ')}>
      <div className='ask-content_questions'>
        {question.map((q, index)=>(
          <Text
            key={index}
            className='ask-content__question'
            content={q.text}
          />
        ))}
      </div>
      <div className='ask-content__answers'>
        {
          answerType !== 'text_entry'
            ? answers.map((a,index) => (
              <Answer
                key={a._id}
                answerType={answerType}
                onChange={!disabled ? inputAnswer : ()=>{return null}}
                answer={a}
                hasSubmitted={hasSubmitted}
                isCorrect={isCorrect}
                checked={givenAnswer.indexOf(a._id) !== -1}
              />
            ))
            : <TextInputAnswer
              onChange={inputAnswer}
              hasSubmitted={hasSubmitted}
              isCorrect={isCorrect}
              submitAnswer={submitAnswer}
              givenAnswer={givenAnswer.length ? givenAnswer[0] : ''}
            />
        }
      </div>
      {
        as !== 'grandmasterProblem'
          ? <div className='ask-content__foot'>
            <div className='ask-content__buttons'>
              {
                hasSubmitted && isCorrect
                  ? <span className='ask-content__results ask-content__results--correct'>Good Job!</span>
                  : hasSubmitted
                    ? <span className='ask-content__results ask-content__results--incorrect'> Incorrect. </span>
                    : null
              }
              <TertiaryButtonDark onClick={revealAnswer}> Show Solution </TertiaryButtonDark>
              {
                !hasSubmitted
                  ? <PrimaryButton className='ask-content__check-button' onClick={submitAnswer}>Check</PrimaryButton>
                  : (hasSubmitted && isCorrect)
                    ? <PrimaryButton className='ask-content__check-button' onClick={submitAnswer} disabled>Check</PrimaryButton>
                    : <SecondaryButton className='ask-content__check-button' onClick={submitAnswer}>Try Again</SecondaryButton>
              }
            </div>
          </div>
          : null
      }
    </form>
  )
}

export default Ask



// WEBPACK FOOTER //
// ./src/core/components/interactive-content-blocks/ask/Ask.js